import { AnalysisPayload } from "containers/dashboard/types";
import { Client } from "./config";

export function FetchAnalysis(student_id: string) {
  return Client.get<AnalysisPayload>(`/data/first_graph?userID=${student_id}`);
}
